export default {
  zh: {
    businessInformation: "商业信息",
    addressLine1: "地址1:",
    addressLine2: "地址2:",
    addressLine3: "地址3:",
    state: "州/邦:",
    registeredTitle: "注册地址",
    regOptionMain: "我们同意采用星中商务的注册地址",
    serviceAddressTitle: "服务地址",
    sameAsRegisteredAddress: "与注册地址相同",
    serviceOtherMain: "采用其他服务地址 (须英文输入)",
    contactTitle: "联系方式",
    email: "邮箱",
    phoneNumber: "电话",
    natureOfBusinessTitle: "业务性质",
    businessDescription: "业务描述",
    msicCodes: "MSIC代码(最多3个)",
    constitutionOption01: "不采纳公司章程",
    constitutionOption01Desc: "依据《2016年公司法》运作",
    constitutionOption02: "定制化章程(该选项下需要申请人在下一步骤上传经本地律师复核的定制化章程)",
  },
  en: {
    businessInformation: "Business Information",
    addressLine1: "Address line 1:",
    addressLine2: "Address line 2:",
    addressLine3: "Address line 3:",
    state: "State:",
    registeredTitle: "Registered Address",
    regOptionMain: 'Consent to use Estar Business Advisory Sdn. Bhd. ("EStar")\'s registration address',
    serviceAddressTitle: "Service Address",
    sameAsRegisteredAddress: "Same As Registered Address",
    serviceOtherMain: "Use other service address (English Only)",
    contactTitle: "Contact Information",
    email: "Email",
    phoneNumber: "Mobile",
    natureOfBusinessTitle: "NATURE OF BUSINESS",
    businessDescription: "Business Description",
    msicCodes: "MSIC Code(Maximum 3)",
    constitutionOption01: "No Constitution",
    constitutionOption01Desc: "Governed by the Companies Act 2016",
    constitutionOption02: "Customized constitution (customized constitution reviewed by local legal is required to be uploaded in the next step under this option)",
  },
};
